import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UiWebBannerComponent } from '@drct-web-apps/ui-web-banner';
import { UiWebDrcComponent } from '@drct-web-apps/ui-web-drc';
import { UiWebEventsComponent } from '@drct-web-apps/ui-web-events';
import { UiWebHomeScheduleComponent } from '@drct-web-apps/ui-web-home-schedule';
import { UiWebMinistriesComponent } from '@drct-web-apps/ui-web-ministries';
import { UiWebTestimoniesComponent } from '@drct-web-apps/ui-web-testimonies';



@Component({
  selector: 'ui-web-central',
  templateUrl: './ui-web-central.component.html',
  imports: [ UiWebMinistriesComponent, UiWebTestimoniesComponent, UiWebEventsComponent,
             UiWebBannerComponent, UiWebDrcComponent, UiWebHomeScheduleComponent ]
})
export class UiWebCentralComponent {

  constructor(private readonly router: Router) { }

  public onClickAllEvents(): void {
    this.router.navigate(['home','events']);
  }

  public onClickMoreTestimonies(): void {
    this.router.navigate(['home','testimonies']);
  }
}